// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/StockTake.css
// module id = 414
// module chunks = 0